import * as React from 'react'
import { PropsWithChildren, ReactElement } from 'react'
import { Callout, DirectionalHint, getId, ICalloutProps, Icon, Link } from '@fluentui/react'
import { useBoolean, useConst } from '@fluentui/react-hooks'
import useViewport from '../hooks/useViewport'
import { makeStyles } from '@fluentui/react-components'

type Props = PropsWithChildren<{
    calloutProps?: Omit<ICalloutProps, 'target' | 'onDismiss'>
}>

const useStyles = makeStyles({ link: { display: 'block', height: '1em' } })

// noinspection JSUnusedGlobalSymbols
export default function InfoTooltip(props: Props): ReactElement {
    const styles = useStyles()
    const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false)
    const id = useConst<string>(getId())
    const { height, width } = useViewport()

    return (
        <>
            <Link id={id} underline={false} className={styles.link} onClick={toggleIsCalloutVisible}>
                <Icon iconName="Info" />
            </Link>
            {isCalloutVisible && (
                <Callout
                    directionalHint={DirectionalHint.topCenter}
                    calloutMaxWidth={width - 16}
                    calloutMaxHeight={height / 2 - 16}
                    {...props.calloutProps}
                    target={`#${id}`}
                    onDismiss={toggleIsCalloutVisible}
                >
                    {props.children}
                </Callout>
            )}
        </>
    )
}
